// extracted by mini-css-extract-plugin
export default {"head":"Finder_head__sZmjP","page":"Finder_page__p4E-0","search":"Finder_search__HiTDD","blockFind":"Finder_blockFind__Wg7Nn","resBtn":"Finder_resBtn__49JQP"};